import axiosInstance from "./axios";

export const foodItemsFetcher = async () =>
  axiosInstance
    .get("/meals/food-items-handler")
    .then((response) => response.data);

export const sendClientDataRequest = async (data) =>
  axiosInstance.post("clients-forms/form-data-handler", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const cardioEquipmentsFetcher = async () =>
  axiosInstance
    .get("/workout-plan-algorithm/cardio-equipments-handler")
    .then((response) => response.data);

export const checkClientFormStatusRequest = async () =>
  axiosInstance
    .get("/clients/check_client_form_status")
    .then((response) => response.data);

export const checkClientFormRefillStatusRequest = async () =>
  axiosInstance
    .get("/clients/check-client-form-refill-status")
    .then((response) => response.data);

export const supplementsFetcher = async () =>
  axiosInstance
    .get("/supplements/supplements-handler")
    .then((response) => response.data);

export const clientDataViaSecretCodeFetcher = async (requestData) =>
  axiosInstance
    .post("/clients/client-data-via-secret-code", requestData)
    .then((response) => response.data);

export const foodItemsExclusionCategorisFetcher = async () =>
  axiosInstance
    .get("/meals/food-items-exclusion-categories-handler")
    .then((response) => response.data);

export const fetchClientFormDataRequest = async () =>
  axiosInstance
    .get("/clients/client-previous-form-handler")
    .then((response) => response.data);

export const freezeHandler = async (freezeDuration) =>
  axiosInstance
    .get("/clients/freeze-handler", { params: { freezeDuration } })
    .then((response) => response.data);

export const clientProgramStatusFetcher = async () =>
  axiosInstance
    .get("clients-accounts-experiences/client-program-status")
    .then((response) => response.data);
